module.exports = __webpack_public_path__ + "img/print_barcode_white.cf137248.svg";